// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const IndustryRef = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "status": zod.enum(['approved', 'pending'])
});

export type IndustryRef = zod.input<typeof IndustryRef>;
export type IndustryRefOutput = zod.output<typeof IndustryRef>;
